import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA9_fo1bEygZLLlq3nWIwmY3g2QNuBqJVE",
  authDomain: "exam-guide-tutorial.firebaseapp.com",
  projectId: "exam-guide-tutorial",
  storageBucket: "exam-guide-tutorial.appspot.com",
  messagingSenderId: "580228868515",
  appId: "1:580228868515:web:f8c5ade9867a9d10b05216",
  measurementId: "G-FMBXK7GN3C"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth }; 